import { useEffect, useState } from 'react'

// True once the page has scrolled past `offset` pixels. Server-safe: false until mounted.
export const useScrolled = (offset = 16): boolean => {
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const update = () => setScrolled(window.scrollY > offset)

        update()
        window.addEventListener('scroll', update, { passive: true })

        return () => window.removeEventListener('scroll', update)
    }, [offset])

    return scrolled
}
